import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const Notification = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25 45.8331C26.1042 45.83 27.1622 45.39 27.943 44.6092C28.7237 43.8285 29.1637 42.7704 29.1669 41.6663H20.8331C20.8363 42.7704 21.2763 43.8285 22.057 44.6092C22.8378 45.39 23.8958 45.83 25 45.8331ZM37.5 33.3331V22.9163C37.5 16.5206 34.1044 11.1663 28.125 9.74938V8.33313C28.125 7.50432 27.7958 6.70947 27.2097 6.12342C26.6237 5.53737 25.8288 5.20813 25 5.20813C24.1712 5.20813 23.3763 5.53737 22.7903 6.12342C22.2042 6.70947 21.875 7.50432 21.875 8.33313V9.75C15.9169 11.1669 12.5 16.5 12.5 22.9169V33.3331L8.33313 37.5V39.5831H41.6663V37.5L37.5 33.3331ZM33.3331 35.4163H16.6663V22.9163C16.6663 17.7494 19.8119 13.5413 24.9994 13.5413C30.1869 13.5413 33.3331 17.75 33.3331 22.9163V35.4163Z"
        fill={color}
      />
    </svg>
  )
}
